/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   09/08/2022
 */

import {gql} from "urql";
import {SlackConversation} from "../../interfaces/Global";

export const slackUserConversationsQuery = gql`
	query SlackUserConversations {
        slackUserConversations {
	        ok
	        error
	        conversations {
		        id
		        name
		        isChannel
		        isGroup
		        isPrivate
            }
        }
	}
`;

export interface SlackUserConversationsResponse {
	slackUserConversations: {
		ok: boolean
		error?: string
		conversations: SlackConversation[]
	}
}